module.exports = __webpack_public_path__ + "media/images/guideline/H_01-97552ac276c7ede51595b68485c59ea6.jpg";